/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControlRequirementRead } from '../models/ControlRequirementRead';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ControlRequirementLinksService {
    /**
     * Link Control To Requirement
     * @returns ControlRequirementRead Successful Response
     * @throws ApiError
     */
    public static linkControlToRequirementControlsControlIdRequirementsRequirementIdPost({
        controlId,
        requirementId,
        createdBy,
    }: {
        controlId: number,
        requirementId: number,
        createdBy?: (string | null),
    }): CancelablePromise<ControlRequirementRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/controls/{control_id}/requirements/{requirement_id}',
            path: {
                'control_id': controlId,
                'requirement_id': requirementId,
            },
            query: {
                'created_by': createdBy,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Unlink Control From Requirement
     * @returns any Successful Response
     * @throws ApiError
     */
    public static unlinkControlFromRequirementControlsControlIdRequirementsRequirementIdDelete({
        controlId,
        requirementId,
    }: {
        controlId: number,
        requirementId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/controls/{control_id}/requirements/{requirement_id}',
            path: {
                'control_id': controlId,
                'requirement_id': requirementId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Requirements For Control
     * @returns ControlRequirementRead Successful Response
     * @throws ApiError
     */
    public static listRequirementsForControlControlsControlIdRequirementsGet({
        controlId,
    }: {
        controlId: number,
    }): CancelablePromise<Array<ControlRequirementRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/controls/{control_id}/requirements',
            path: {
                'control_id': controlId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Controls For Requirement
     * @returns any Successful Response
     * @throws ApiError
     */
    public static listControlsForRequirementControlsRequirementsRequirementIdControlsGet({
        requirementId,
    }: {
        requirementId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/controls/requirements/{requirement_id}/controls',
            path: {
                'requirement_id': requirementId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
